import React from 'react';
import PublicBookingLayout from '../../PublicBooking/PublicBookingLayout';

const PublicBookingPageSkeleton = ({ primaryColor = 'blue-600', secondaryColor = 'slate-500' }) => {
  return (
    <PublicBookingLayout primaryColor={primaryColor} secondaryColor={secondaryColor}>
      <div className="py-8">
        <div className="animate-pulse">
          {/* Header skeleton */}
          <div className="bg-white shadow-sm border-b border-ink-100 mb-8">
            <div className="py-8 px-6 sm:px-8">
              <div className="flex items-center">
                <div className="w-16 h-16 bg-cream-300 rounded-full mr-4"></div>
                <div>
                  <div className="h-8 bg-cream-300 rounded w-64 mb-2"></div>
                  <div className="h-4 bg-cream-300 rounded w-96"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Services skeleton */}
          <div className="bg-white rounded-lg shadow-sm border border-ink-100 p-6">
            <div className="h-6 bg-cream-300 rounded w-1/4 mb-6"></div>
            <div className="space-y-4">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="border border-ink-100 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <div className="w-16 h-16 bg-cream-300 rounded-lg"></div>
                      <div>
                        <div className="h-4 bg-cream-300 rounded w-32 mb-2"></div>
                        <div className="h-3 bg-cream-300 rounded w-24"></div>
                      </div>
                    </div>
                    <div className="h-8 bg-cream-300 rounded w-20"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PublicBookingLayout>
  );
};

export default PublicBookingPageSkeleton;